export default "__VITE_ASSET__CmcMGAAZ__"